module.exports = __webpack_public_path__ + "img/4.72374ba1.png";